var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"data-component":"counter","data-align":_vm.align},domProps:{"innerHTML":_vm._s(_vm.getString)}})}
var staticRenderFns = []

export { render, staticRenderFns }